export var KEY_NUMBERS = {
  KEY_ENTER: 13,
  KEY_SPACE: 32
};